module.exports = __webpack_public_path__ + "static/media/lower-page.e467e3ed.svg";